import jwtDecode from "jwt-decode";

export const mapToObject = (map: any) => {
  return Array.from(map).reduce(
    (paramObj: any, [key, value]: any) => Object.assign(paramObj, { [key]: value }),
    {}
  );
};

export const formatFormChangedValue = (value: any) => {
  const newValue = { key: "", val: "" };
  for (const key in value) {
    newValue.key = key;
    newValue.val = value[key];
  }
  return newValue;
};

export const capitalizaFirstLetter = (str: string) => {
  return str.toLowerCase().charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const JWTDecode = () => {
  try {
    const nameJWT = localStorage.getItem("token");
    if (!nameJWT) return "";
    const decoded = jwtDecode<{ username?: string }>(nameJWT);
    return decoded["username"] ?? "";
  } catch (error) {
    console.error(error);
    return "";
  }
};
